exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".time-zone {\n  color: #aaa;\n  font-size: 12px;\n  position: absolute;\n  right: 225px;\n  top: 28px;\n}\n", ""]);

// exports
